import SimpleBar from "simplebar";

function CustomScrollbar() {
	this.selectors = {
		container: "[data-custom-scrollbar]"
	};

	this.containers = document.querySelectorAll(this.selectors.container);

	if (!this.containers.length) {
		return null;
	}

	this.containers.forEach(container => {
		this.initScrollbar(container);
	});
}

CustomScrollbar.prototype.initScrollbar = function (container) {
	let options = {};

	let customOptions = container.dataset.customScrollbarOptions;

	if (customOptions) {
		options = {
			...options,
			...JSON.parse(customOptions)
		}
	}

	new SimpleBar(container, options);
};

export default CustomScrollbar;
